import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
export function EditCoupon() {
  return <div className="space-y-6 max-w-2xl mx-auto" data-id="element-187">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-188">Edit Coupon</h1>

      <Card data-id="element-189">
        <CardContent className="space-y-6 pt-6" data-id="element-190">
          <Input label="Coupon Code" defaultValue="SUMMER23" data-id="element-191" />

          <Select label="Discount Type" options={[{
          value: 'dollar',
          label: 'Dollar Amount'
        }, {
          value: 'percent',
          label: 'Percentage'
        }]} data-id="element-192" />

          <Select label="Usage Type" options={[{
          value: 'customer',
          label: 'Per Customer'
        }, {
          value: 'general',
          label: 'General Use'
        }, {
          value: 'unlimited',
          label: 'Unlimited'
        }, {
          value: 'unlimited_customer',
          label: 'Unlimited by Customer'
        }]} data-id="element-193" />

          <Select label="Group" options={[{
          value: 'par',
          label: 'PAR'
        }, {
          value: 'saar',
          label: 'SAAR'
        }]} data-id="element-194" />

          <Input label="Discount Amount" defaultValue="20" data-id="element-195" />
          <Input label="Uses" defaultValue="0" data-id="element-196" />

          <Select label="Expire Date" options={[{
          value: 'not_set',
          label: 'Not Set'
        }, {
          value: 'set',
          label: 'Set'
        }]} data-id="element-197" />

          <Select label="Limitations" options={[{
          value: 'all',
          label: 'All Courses/Packages'
        }, {
          value: 'single',
          label: 'Only Single Course'
        }, {
          value: 'specific_course',
          label: 'Specific Course'
        }, {
          value: 'specific_package',
          label: 'Specific Package'
        }]} data-id="element-198" />

          <Select label="Exceed?" options={[{
          value: 'no',
          label: 'No'
        }, {
          value: 'yes',
          label: 'Yes'
        }]} data-id="element-199" />

          <div className="pt-4" data-id="element-200">
            <Button data-id="element-201">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}